module.exports = __webpack_public_path__ + "images/bg-global-37f2ff1c.png";